import "../../../assets/js/app.js"
import { mount } from 'svelte';
import App from "./App.svelte";

document.addEventListener("DOMContentLoaded",()=> {
  const figure = document.getElementById("biz-rates-and-fees-figure")
  figure? mount(App, { target: figure }):null;
})
